export default "/images/a515fb8febd5df08737a375f8cf71cea.avif";